<div class="popup-main popup--overlay" *ngIf="!ispopUpShow" style="display: flex;">
  <div class="popup">
    <div class="title">
      <!-- <span class="mr-2 info-icon material-symbols-outlined"> info </span> -->
      <!-- Leaderboard Calculation -->
    </div>
      <button class="popup--close"><span class="icon-close1" (click)="closePop()"></span></button>
      <div class="popup__content">
         <strong style="font-size: 18px;margin-bottom: 10px;margin-top: 10px;">How ranks are awarded</strong>
         
         <ul style="text-align: initial;margin-left: 12px;">
           <li>
            Your rank is based on your progress through the program. If you have the same progress as someone else, the person who completed the program first will have a higher rank
           </li>
           <li>
            Your rank is updated in real time as you progress through the program
           </li>
         </ul>
         
         <strong style="font-size: 18px;margin-bottom: 10px;margin-top: 10px;">How tags are awarded</strong>
         
         <ul style="text-align: initial;margin-left: 12px;">
           <li>
            Your tags are based on your progress compared to the ideal progress for your current day. The ideal progress is calculated by dividing the total program progress by the number of days in the program
           </li>
           <li>
            If you are more than 100% of the ideal progress, you will be tagged as a <span class="leaderboard-info-superstar">Superstar</span>
           </li>
           <li>
            If you are between 80% and 100% of the ideal progress, you will be tagged as an <span class="leaderboard-info-achiever">Achiever</span>
           </li>
           <li>
            If you are less than 80% of the ideal progress, you will be tagged as a <span class="leaderboard-info-novice">Novice</span>
           </li>
         </ul>
        
         <strong style="font-size: 18px;margin-bottom: 10px;margin-top: 10px;">Example scenario</strong>
         
         <ul style="text-align: initial;margin-left: 12px;">
           <li>
            The program is 90 days long, so the ideal progress per day is 1.11%.
           </li>
           <li>
            On day 1, a learner who has just logged in and has made no progress will be tagged as a <span class="leaderboard-info-novice">Novice</span>
           </li>
           <li>
            If the learner then makes 0.89% of progress, they will be tagged as an <span class="leaderboard-info-achiever">Achiever</span>. They will remain an <span class="leaderboard-info-achiever">Achiever</span> until they reach 1.11% of progress, at which point they will be tagged as a <span class="leaderboard-info-superstar">Superstar</span>
           </li>
           <li>
            On day 2, if the learner logs in with 1.5% of progress, they will still be tagged as a <span class="leaderboard-info-novice">Novice</span> because this is less than the minimum progress for day 2, which is 1.78% (0.8 * 2.22%)
           </li>
           <li>
            If the learner then makes 2.22% of progress, they will be tagged as an <span class="leaderboard-info-achiever">Achiever</span>. They will remain an <span class="leaderboard-info-achiever">Achiever</span> until they reach 2.22% of progress, at which point they will be tagged as a <span class="leaderboard-info-superstar">Superstar</span>
           </li>
         </ul>
      </div>

  </div>
  </div>